"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.makeDataSelectors = makeDataSelectors;
function makeDataSelectors(options) {
    return {
        id: item => item[options.id]
    };
}
//# sourceMappingURL=makeDataSelectors.js.map


// WEBPACK FOOTER //
// ./node_modules/redux-saga-resources/node/resource/makeDataSelectors.js